module.exports = __webpack_public_path__ + "img/layout_form_horizontal_icon.4ff8b9a6.svg";